import { styled } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

export const DetailPanelContentStyling = styled(DataGridPremium)(
  ({ theme }) => {
    return {
      borderRadius: 10,
      '& .MuiDataGrid-virtualScroller': { minHeight: theme.spacing(12) },
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        scale: 'revert',
      },
      '--unstable_DataGrid-headWeight': theme.typography.fontWeightRegular,
      '& .MuiDataGrid-columnHeaders': {
        border: 0,
        paddingLeft: 'revert',
        scale: 'revert',
        borderRadius: 'revert',
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
        marginBottom: 0,
      },
      '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
        {
          outline: 'none',
        },
      '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
        outline: 'none',
      },
    };
  }
);
